import type { JointSaleState } from '@/service'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { getJointSaleStateApi } from '@/service'
import { useUserStore } from './user'

/**
 * 联卖认证状态：跨页共享（原型要求认证状态与首页 / 工作台实时同步展示），
 * 各页 onShow 时调用 refresh() 拉取最新状态。不持久化。
 */
export const useJointSaleStore = defineStore('joint-sale', () => {
  const jointState = ref<JointSaleState | null>(null)

  /**
   * 是否已认证联卖经纪人。
   * 「审核中」「驳回」等细分态由消费方读 jointState.jointSaleState 判断（见 verify-card）
   */
  const isJointSale = computed(() => jointState.value?.isJointSale ?? false)

  /** 刷新认证状态；未登录时清空。失败静默（onShow 高频调用，避免重复 toast） */
  async function refresh() {
    if (!useUserStore().isLogined) {
      jointState.value = null
      return
    }
    try {
      const res = await getJointSaleStateApi()
      jointState.value = res.data
    }
    catch {
      // 静默：保留上一次状态
    }
  }

  const reset = () => {
    jointState.value = null
  }

  return { jointState, isJointSale, refresh, reset }
})
